import { useState, useEffect, useRef } from "react";
import { api } from "../config/api.js";
import { setVisibleInterval } from "../utils/visibleInterval.js";

const DEMO_ID = "bloom-demo-001";

export function useRealtimeOrders(storeId, onNewOrder) {
  const [live,    setLive]    = useState(false);
  const knownIds = useRef(null);

  useEffect(() => {
    if (!storeId || storeId === DEMO_ID) return;

    const poll = async () => {
      try {
        const orders = await api.getOrdersByStore(storeId);
        if (!Array.isArray(orders)) return;
        const ids = new Set(orders.map(o => o.id));

        if (knownIds.current === null) {
          knownIds.current = ids;
          setLive(true);
          return;
        }

        for (const order of orders) {
          if (!knownIds.current.has(order.id)) {
            knownIds.current.add(order.id);
            onNewOrder({ ...order, date: order.order_date, items: order.items || [] });
          }
        }
        setLive(true);
      } catch {
        setLive(false);
      }
    };

    poll();
    const stopPoll = setVisibleInterval(poll, 30_000);
    return () => stopPoll();
  }, [storeId]);

  return live;
}
